<div *hideItBootstrap="['xs']">
  <div class="position-absolute right-0">
    <ng-container *showItBootstrap="['lg', 'xl']" [ngTemplateOutlet]="desktop"></ng-container>
    <ng-container *showItBootstrap="['sm', 'md']" [ngTemplateOutlet]="tablet"></ng-container>
  </div>
  <ng-container [ngTemplateOutlet]="alerts"></ng-container>
  <ng-container [ngTemplateOutlet]="welcome"></ng-container>
</div>
<ng-container *showItBootstrap="['xs']">
  <ng-container [ngTemplateOutlet]="alerts"></ng-container>
  <ng-container [ngTemplateOutlet]="welcome"></ng-container>
  <div class="d-flex justify-content-end">
    <ng-container *sm [ngTemplateOutlet]="tablet"></ng-container>
    <ng-container *xs [ngTemplateOutlet]="mobile"></ng-container>
  </div>
</ng-container>

<ng-template #alerts>
  @for (alert of profileAlerts; track alert) {
    <fss-app-alert
      [alert]="alert"
      (ctaClick)="setAccountNumberAndNavigate($event)"
      class="d-block container position-relative fss-app-alert"
    ></fss-app-alert>
  }
</ng-template>

<ng-template #welcome>
  <div class="welcome-message-container">
    <div class="container">
      <h1 class="welcome-message-text mb-0 mt-0">
        <span>{{ 'greeting' | translate }}</span>
      </h1>
    </div>
  </div>
</ng-template>

<ng-template #tablet>
  <svg
    height="116px"
    viewBox="0 0 412 116"
    width="412px"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fill-rule="evenodd" id="account-overview" stroke="none" stroke-width="1">
      <g id="id1" transform="translate(-356.000000, -64.000000)">
        <g id="id2" transform="translate(0.000000, 64.000000)">
          <g id="id3">
            <g id="id4">
              <g id="id5">
                <g transform="translate(356.000000, 0.000000)">
                  <polygon
                    fill="#CCEFEE"
                    fill-opacity="0.5"
                    id="id6"
                    points="-6.02372124e-14 6.74321996e-14 296.002043 0 378 100"
                  ></polygon>
                  <polygon fill="#FFFAC6" id="id7" points="261 0 852 0 852 173 448 173"></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #desktop>
  <svg
    height="116px"
    viewBox="0 0 797 116"
    width="797px"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <rect height="116" id="path-1" width="797" x="0" y="0"></rect>
    </defs>
    <g fill="none" fill-rule="evenodd" id="id1" stroke="none" stroke-width="1">
      <g id="id2" transform="translate(-643.000000, -145.000000)">
        <g id="id3" transform="translate(643.000000, 145.000000)">
          <mask fill="white" id="mask-2">
            <use xlink:href="#path-1"></use>
          </mask>
          <use fill="#FFFFFF" id="Mask" xlink:href="#path-1"></use>
          <g id="BG-accent" mask="url(#mask-2)">
            <g transform="translate(17.000000, 0.000000)">
              <polygon
                fill="#CCEFEE"
                fill-opacity="0.5"
                id="id4"
                points="-6.02372124e-14 6.74321996e-14 296.002043 0 378 100"
              ></polygon>
              <polygon fill="#FFFAC6" id="id5" points="261 0 852 0 852 173 448 173"></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #mobile>
  <svg
    height="84px"
    viewBox="0 0 320 84"
    width="320px"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <rect height="84" id="path-1" width="320" x="0" y="0"></rect>
    </defs>
    <g fill="none" fill-rule="evenodd" id="id1" stroke="none" stroke-width="1">
      <g id="id2" transform="translate(0.000000, -64.000000)">
        <g id="id3" transform="translate(0.000000, 64.000000)">
          <g>
            <mask fill="white" id="mask-2">
              <use xlink:href="#path-1"></use>
            </mask>
            <use fill="#F6F6F6" id="Mask" xlink:href="#path-1"></use>
            <g id="accent" mask="url(#mask-2)">
              <g id="mobile-bg-accent" transform="translate(104.000000, 0.000000)">
                <g>
                  <polygon
                    fill="#CCEFEE"
                    fill-opacity="0.5"
                    id="id4"
                    points="-2.85250291e-14 3.91106758e-14 141.151148 0.59556661 179 58"
                  ></polygon>
                  <polygon fill="#FFFAC6" id="id5" points="75 0 510 0 510 88 214 126"></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
